import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from '../../../../../../common/components/reactive-form-builder/interfaces/input.interface';
import { TareaCespedModel } from '../../../../../../models/tareas/tarea-cesped.model';
import { MtoReactiveFormDefinition, MtoSectionSpec } from '../../../mto-reactive/mto-reactive-form-definition';

export class TareasMtoCespedFormDefinition extends MtoReactiveFormDefinition<TareaCespedModel> {
    constructor(type: FormType = FormType.CREATION, model: Partial<TareaCespedModel> = {}) {
        super(type, model);

        this.initializeMtoForm({
            name: 'cesped',
            header: 'Datos de césped/cavado',
            database: 'tareas_mto_cesped',
            signatureFolder: 'cesped',
            sections: this.getSections(),
        });
    }

    private getSections(): MtoSectionSpec<TareaCespedModel>[] {
        return [
            { name: 'Datos de césped/cavado', fields: [...this.getDefaultMainFieldSpecs()] },
            { name: 'Cortes', fields: [
                this.field('corte_desbroce', `Corte/Desbroce`, InputType.SWITCH, { width: 3 }),
                this.field('escarificado', `Escarificado`, InputType.SWITCH, { width: 3 }),
                this.field('aireado_pinchado', `Aireado/Pinchado`, InputType.SWITCH, { width: 3 }),
                this.field('soplado', `Soplado`, InputType.SWITCH, { width: 3 }),
                this.field('escarda_hierba', `Escarda hierba`, InputType.SWITCH, { width: 3 }),
            ] },
            { name: 'Cavados', fields: [
                this.field('parterres', `Parterres`, InputType.SWITCH, { width: 3 }),
                this.field('arriates', `Arriates`, InputType.SWITCH, { width: 3 }),
                this.field('jardineras', `Jardineras`, InputType.SWITCH, { width: 3 }),
            ] },
            { name: 'Recebado', fields: [
                this.field('sacas_una_tonelada', `Sacas ( 1 tonelada )`, InputType.NUMERIC, { width: 3 }),
                this.field('sacas_media_tonelada', `Sacas ( 1/2 tonelada )`, InputType.NUMERIC, { width: 3 }),
                this.field('sacos_venticinco', `Sacos ( 25Kg )`, InputType.NUMERIC, { width: 3 }),
                this.field('kilos_granel', `Kilos a granel`, InputType.NUMERIC, { width: 3 }),
                this.field('sacos_ciemhus_litros', `Sacos Ciemhus ( 50l )`, InputType.NUMERIC, { width: 3 }),
                this.field('recebado_portes', `Portes`, InputType.DROPDOWN, { data: this.lists.portes, width: 3 }),
            ] },
            { name: 'Tierra vegetal', fields: [
                this.field('vegetal_sacas_una_tonelada', `Sacas ( 1 tonelada )`, InputType.NUMERIC, { width: 3 }),
                this.field('vegetal_sacas_media_tonelada', `Sacas ( 1/2 tonelada )`, InputType.NUMERIC, { width: 3 }),
                this.field('vegetal_sacos_venticinco', `Sacos ( 25Kg )`, InputType.NUMERIC, { width: 3 }),
                this.field('vegetal_kilos_granel', `Kilos a granel`, InputType.NUMERIC, { width: 3 }),
                this.field('vegetal_sacos_ciemhus_litros', `Sacos Ciemhus ( 50l )`, InputType.NUMERIC, { width: 3 }),
                this.field('vegtal_portes', `Portes`, InputType.DROPDOWN, { data: this.lists.portes, width: 3 }),
            ] },
            { name: 'Tierra preparada', fields: [
                this.field('preparada_sacas_una_tonelada', `Sacas ( 1 tonelada )`, InputType.NUMERIC, { width: 3 }),
                this.field('preparada_sacas_media_tonelada', `Sacas ( 1/2 tonelada )`, InputType.NUMERIC, { width: 3 }),
                this.field('preparada_sacos_venticinco', `Sacos ( 25Kg )`, InputType.NUMERIC, { width: 3 }),
                this.field('preparada_kilos_granel', `Kilos a granel`, InputType.NUMERIC, { width: 3 }),
                this.field('preparada_sacos_ciemhus_litros', `Sacos Ciemhus ( 50l )`, InputType.NUMERIC, { width: 3 }),
                this.field('preparada_portes', `Portes`, InputType.DROPDOWN, { data: this.lists.portes, width: 3 }),
            ] },
            { name: 'Tierra garbillada', fields: [
                this.field('garvillada_sacas_una_tonelada', `Sacas ( 1 tonelada )`, InputType.NUMERIC, { width: 3 }),
                this.field('garvillada_sacas_media_tonelada', `Sacas ( 1/2 tonelada )`, InputType.NUMERIC, { width: 3 }),
                this.field('garvillada_sacos_venticinco', `Sacos ( 25Kg )`, InputType.NUMERIC, { width: 3 }),
                this.field('garvillada_kilos_granel', `Kilos a granel`, InputType.NUMERIC, { width: 3 }),
                this.field('garvillada_sacos_ciemhus_litros', `Sacos Ciemhus ( 50l )`, InputType.NUMERIC, { width: 3 }),
                this.field('garvillada_portes', `Portes`, InputType.DROPDOWN, { data: this.lists.portes, width: 3 }),
            ] },
            { name: 'Siembra césped', fields: [
                this.field('siembra_cesped_kg', `Kg`, InputType.NUMERIC, { width: 3 }),
                this.field('siembra_cesped_gramos', `Gramos`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Siembra grama', fields: [
                this.field('siembra_grana_kg', `Kg`, InputType.NUMERIC, { width: 3 }),
                this.field('siembra_grana_gramos', `Gramos`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Siembra dichondra', fields: [
                this.field('siembra_dichondra_kg', `Kg`, InputType.NUMERIC, { width: 3 }),
                this.field('siembra_dichondra_gramos', `Gramos`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Sustrato', fields: [
                this.field('sustrato_sacos_venticinco', `Sacos ( 25Kg )`, InputType.NUMERIC, { width: 3 }),
                this.field('sustrato_femabon', `Sacos Femabon ( 25l )`, InputType.NUMERIC, { width: 3 }),
                this.field('sustrato_ciemhus', `Sacos Ciemhus ( 70l )`, InputType.NUMERIC, { width: 3 }),
                this.field('sustrato_acido', `Sacos sustrato ácido ( 20l )`, InputType.NUMERIC, { width: 3 }),
            ] },
            this.workerSection('Profesionales'),
            this.workOrderSection(),
            this.observationSection('Observaciones'),
        ];
    }
}
